// @ts-strict-ignore
import {Directive, ElementRef, Injector, Input} from "@angular/core";
import {SimPermissionService} from "@services";
import {DataPermissions, DataPermissionType, Permissions} from "@models";
import {MatTooltip} from "@angular/material/tooltip";
import {PermissionTooltipDirective} from "./permission-tooltip.directive";

@Directive({
	selector: "[hasDataPermission]",
	providers: [MatTooltip],
	standalone: true,
})
export class HasDataPermissionDirective extends PermissionTooltipDirective {
	private permissionDebug: boolean = false;
	@Input({alias: "hasDataPermission", required: true}) permission: keyof typeof DataPermissions | Array<keyof typeof DataPermissions>;
	@Input() permissionType: keyof typeof DataPermissionType;
	@Input() permissionObj: any;

	constructor(
		private element: ElementRef,
		private _simPermissionService: SimPermissionService,
		injector: Injector,
	) {
		super(injector);
		this.element = element.nativeElement;
	}

	ngOnInit(): void {
		this.changeElementAccordingToPermission();
		typeof this.permission === "number"
			? (this.message = Permissions[this.permission])
			: (this.message = this.permission?.toString() ?? "No permission set");
		this.setupTooltip();
	}

	ngOnChanges(): void {
		this.changeElementAccordingToPermission();
	}

	private changeElementAccordingToPermission(): void {
		const active = this.getIsActive();

		// Modify DOM
		if ($(this.element).hasClass("td")) {
			if (active) {
				$(this.element).removeClass("inactive");
			} else {
				$(this.element).addClass("inactive");
			}
		} else {
			if (active) {
				if (this.permissionDebug) {
					$(this.element).css("border", "2px solid green");
				} else {
					$(this.element).css("display", null);
				}
			} else {
				if (this.permissionDebug) {
					$(this.element).css("border", "2px solid red");
				} else {
					$(this.element).css("display", "none");
				}
			}
		}
	}

	private getIsActive(): boolean {
		let result = false;

		if (this.permission && !Array.isArray(this.permission)) {
			result = this.shouldElementBeActive(this.permission);
		}

		if (this.permission && Array.isArray(this.permission)) {
			result = this.permission.reduce((acc, cur) => acc || this.shouldElementBeActive(cur), false);
		}
		return result;
	}

	private shouldElementBeActive(permission: keyof typeof DataPermissions) {
		// Get permission string
		let permValue: string = permission.trim();

		// Check if negated permission requested
		const notPermissionFlag = permValue[0] === "!";

		if (notPermissionFlag) {
			permValue = permValue.slice(1).trim();
		}

		// Get permission string
		let perm = DataPermissions[permValue];
		if (perm == null) {
			if (this.permissionDebug) {
				$(this.element).css("border", "2px solid orange");
			}
			console.warn(permValue + " not in DataPermissions");
		}

		if (this.permissionObj && this.permissionObj.permissions) {
			const hasPermission = this._simPermissionService.HasDataPerm(
				this.permissionObj,
				perm,
				DataPermissionType[(this.permissionType || "").trim()],
			);

			return (hasPermission && !notPermissionFlag) || (!hasPermission && notPermissionFlag);
		}

		return true;
	}
}
